/*! qrcanvas-vue v2.1.0 | ISC License */
import Vue from 'vue';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import { qrcanvas } from 'qrcanvas';

var Component = {
  props: {
    options: Object
  },
  render: function render(h) {
    var _this$$props = this.$props,
        options = _this$$props.options,
        rest = _objectWithoutPropertiesLoose(_this$$props, ["options"]);

    return h('canvas', rest);
  },
  methods: {
    update: function update(options) {
      // Render only if mounted, skip SSR.
      if (!this.mounted) return;
      this.$emit('beforeUpdate', this.$el);
      qrcanvas(_extends({}, options, {
        canvas: this.$el
      }));
      this.$emit('updated', this.$el);
    }
  },
  watch: {
    options: 'update'
  },
  mounted: function mounted() {
    this.mounted = true;
    this.update(this.options);
  }
};

var QRCanvas = Vue.extend(Component);

export { Component, QRCanvas };
